import React, { useContext, useState, useLazyRef, lazy, useMemo, useEffect } from 'react'
import { Switch, Route } from "react-router-dom";
import { UserContext } from '../../context/provider/UserProvider';

import { InicioTman } from '../pages/InicioTman';
import { Repuestos } from '../pages/registros/Repuestos/Repuestos';
import { Kilometrajes } from '../pages/registros/Kilometrajes';
import { Bim } from '../pages/GestionMantenimiento/Bim';
import { OrdenTrabajo } from '../pages/GestionMantenimiento/OrdenTrabajo';
import { Marcas } from '../pages/registros/Marcas';
import { MovimientosNeumaticos } from '../pages/Neumaticos/MovimientosNeumaticos';

import { LayoutMaster } from '../modules/layout/LayoutMaster';
import { PrivateRoute } from '../components/PrivateRoute';

import PageNotFound from '../pages/PageNotFound';
import { Movimientos } from '../pages/almacen/Movimientos';
import { Almacenes } from '../pages/registros/Almacenes';
import { Neumaticos } from '../pages/Neumaticos/Neumaticos';
import { Kardex } from '../pages/Reportes/Kardex';
import { Reportes } from '../pages/Reportes/Reportes';
import { MantenimientosDefinidos } from '../pages/GestionMantenimiento/MantenimientosDefinidos';
import { SalidaPorOT } from '../pages/almacen/SalidaPorOT';
import MantenimientoNeumaticos from '../pages/GestionNeumaticos/MantenimientoNeumaticos/MantenimientoNeumaticos';

export function PrivateRoutes({ token }) {
    // const { stateUser } = useContext(UserContext);
    return (
        <>
            {                
                token !== '' && localStorage.getItem('currentLocation') !== '/'
                && (
                    <>
                        <LayoutMaster>
                            <Switch>
                                <PrivateRoute path='/tman' component={InicioTman} />
                                <PrivateRoute path='/repuestos' component={Repuestos} />
                                <PrivateRoute path='/kilometrajes' component={Kilometrajes} />
                                <PrivateRoute path='/bim' component={Bim} />
                                <PrivateRoute path='/movimientos' component={Movimientos} />
                                <PrivateRoute path='/orden-trabajo' component={OrdenTrabajo} />
                                <PrivateRoute path='/marcas' component={Marcas} />
                                <PrivateRoute path='/movimientos-neumaticos' component={MovimientosNeumaticos} />
                                <PrivateRoute path='/neumaticos' component={Neumaticos} />
                                <PrivateRoute path='/almacenes' component={Almacenes} />
                                <PrivateRoute path='/salida-por-ot' component={SalidaPorOT} />
                                <PrivateRoute path='/kardex' component={Kardex} />
                                <PrivateRoute path='/consultas-reportes' component={Reportes} />

                                <PrivateRoute path='/mantenimientos-definidos' component={MantenimientosDefinidos} />

                                <PrivateRoute path='/mantenimiento-neumatico' component={MantenimientoNeumaticos} />

                                <Route path="*" component={PageNotFound} />
                            </Switch>
                        </LayoutMaster>
                    </>
                )
            }            
        </>
    )
}